import { createContext, useContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { Show } from "@clerk/react";
import { Hourglass } from "lucide-react";
import { useAuthedApi } from "@/lib/api";

const MeContext = createContext(null);
export const useMe = () => useContext(MeContext);

const RoleCheck = ({ children, adminOnly }) => {
  const api = useAuthedApi();
  const [me, setMe] = useState(null);

  useEffect(() => {
    api("get", "/me").then(setMe).catch(() => setMe({ role: "erro" }));
  }, [api]);

  if (!me) return <div className="mx-auto mt-20 h-40 max-w-4xl animate-pulse rounded-md bg-slate-900/60" />;
  if (me.role === "pendente" || me.role === "erro") {
    return (
      <main data-testid="pending-approval" className="mx-auto max-w-lg px-4 py-24 text-center">
        <Hourglass className="mx-auto mb-4 text-amber-400" size={36} />
        <h1 className="font-display text-3xl font-bold uppercase">Aguardando aprovação</h1>
        <p className="mt-3 text-slate-400">{me.role === "erro" ? "Não foi possível verificar seu acesso. Atualize a página." : "Sua conta foi criada. Um administrador precisa liberar seu acesso para cadastrar e editar eventos."}</p>
      </main>
    );
  }
  if (adminOnly && me.role !== "admin") return <Navigate to="/painel" replace />;
  return <MeContext.Provider value={me}>{children}</MeContext.Provider>;
};

export const StaffGate = ({ children, adminOnly = false }) => (
  <>
    <Show when="signed-in"><RoleCheck adminOnly={adminOnly}>{children}</RoleCheck></Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);
